<div id="container">
    <div class="title">P<sup>3</sup>DB 3.0:</div>
    <div id="quick-search">
        <mat-icon class="icon">search</mat-icon>
        <span id="search-label">Quick Search:</span>
        <input placeholder="Quick Search">
        <button mat-flat-button color="accent">Search</button>
    </div>
</div>